
import React from 'react';
import { PhoneOff } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="px-4 py-8 bg-white border-t border-gray-100">
      <div className="container mx-auto max-w-5xl">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center space-x-2 mb-4 md:mb-0">
            <PhoneOff className="h-5 w-5 text-optout-blue" />
            <span className="font-medium text-optout-text">SMS Opt-Out</span>
          </div>
          
          <div className="text-sm text-optout-lighttext">
            &copy; {new Date().getFullYear()} SMS Opt-Out Service. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
